import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getFinancialArApURL } from "../utils/constants/apiEndPoints";
import { HTTP_STATUS_SUCCESS } from "../utils/constants/appConstants";
import { showToast } from "../utils/utils";
import { responseStatus } from "../locales/en";

const initialState = {
  financialArApData: {},
  arapLoading: false
};

const financialArApSlice = createSlice({
  name: "financialArAp",
  initialState,
  reducers: {
    setGetFinancialArApData(state, action) {
      state.financialArApData = action.payload;
    },
    setArapLoading(state, action) {
      state.arapLoading = action.payload;
    }
  }
});

export const fetchFinancialArApData = createAsyncThunk(
  "financialArAp/fetchFinancialArApData",
  async (payload, { dispatch }) => {
    const { id, notify } = payload;
    try {
      dispatch(setArapLoading(true));
      const response = await payload.privateAxios.get(getFinancialArApURL(id));
      if (
        response.status === 200 &&
        response.data.status === HTTP_STATUS_SUCCESS
      ) {
        dispatch(setArapLoading(false));
        dispatch(setGetFinancialArApData(response.data.data));
        if (notify && response?.data?.message) {
          showToast(response?.data?.message, responseStatus?.success);
        }
      } else return response;
    } catch (error) {
      dispatch(setArapLoading(false));
      if (error.response.status === 500 && notify) {
        showToast(error.response?.data?.message, responseStatus?.error);
      }
    } finally {
      dispatch(setArapLoading(false));
    }
  }
);

export const { setGetFinancialArApData, setArapLoading } =
  financialArApSlice.actions;
export default financialArApSlice.reducer;
